import React, { useEffect, useRef, useState } from 'react';
import './notification.scss';
import { Card, Spin, Alert } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import { getNotification } from '../../../slices/notification/thunk';
import NoResults from '../NoResults/NoResults';
import InfiniteScroll from 'react-infinite-scroll-component';
import DateService from '../../../Services/DateService';
import { Link } from 'react-router-dom';
import { fetchData } from '../../../Services/FetchData';
import { getNotificationAll } from '../../../slices/notificationAll/thunk';



const Notification = () => {
    const dispatch = useDispatch();
    const [hasMore, setHasMore] = useState(true);
    const [page, setPage] = useState(1);
    const [notificationData, setNotificationData] = useState([]);
    const limit = 10;
    const NotificationCard = ({ isRead, title, description, date, adId, imageUrl, type, catalogTitle, catalogDescription, index }) => {
        const keyword = 'ad';
        const today = new Date().toLocaleDateString(); // Get today's date in a locale-friendly format
        let formattedDate = new Date(date).toLocaleDateString();
        const refs = useRef([]);
        if (formattedDate === today) {
            formattedDate = DateService.formatDateCustom(date, true, false);
            console.log('formattedData', formattedDate)
        }
        else {
            formattedDate = DateService.formatDateCustom(date, true, false)
        }
        const newDescription = description

        useEffect(() => {
            if (notificationData?.length > 0) {
                notificationData.forEach((el, index) => {
                    if (el?.type === 'catalog') {
                        const spanRef = refs.current[index]; // Span element
                        const pRef = spanRef?.closest('p'); // Closest <p> parent
                        const divRef = spanRef?.closest('.catalog_cnt'); // Get the closest div with the class 'catalog_cnt'

                        if (spanRef && pRef && divRef) {
                            const spanWidth = spanRef.getBoundingClientRect().width;
                            const pWidth = pRef.getBoundingClientRect().width;

                            if (spanWidth > pWidth) {
                                divRef.classList.add('active'); // Correct method for adding a class
                            }
                        }
                    }
                });
            }
        }, [notificationData]);


        return (
            <Card style={{ marginTop: "24px" }} className={`${isRead ? 'in_active' : 'active'}`}>
                <div className={`notification_body`}>
                    <div className="left">
                        <h4 className='text_red'>{title}</h4>
                        {
                            type === 'catalog' ? (
                                <div className='catalog_cnt'>
                                    <div className="cnt">
                                        <p className='title mb-0' >
                                            {catalogTitle} : <span className='description' ref={(el) => (refs.current[index] = el)}>{catalogDescription}</span>
                                        </p>                                </div>
                                    <span className="date sm2" >{formattedDate}</span>
                                </div>
                            ) : (
                                <>
                                    <p className='mb-0'>
                                        {newDescription}&nbsp;
                                        {adId && <Link to={`/live-ads/${adId}`} className='inner_link'>Ad Id : {adId}</Link>}
                                    </p>
                                    <span className="date sm2">{formattedDate}</span>
                                </>
                            )
                        }
                    </div>
                    {
                        imageUrl && (
                            <div className="right">
                                <figure className={`${type}`}>
                                    <img src={imageUrl} alt="" />
                                </figure>
                            </div>
                        )
                    }

                </div>
            </Card>

        );
    };

    // changing notification status
    const changeNotificationStatus = async () => {
        try {
            const endPoint = '/notifications/read';
            const fetchedData = await fetchData(endPoint, null, 'post'); // Correctly pass 'post' as a string
            dispatch(getNotificationAll({ limit: 101, page: 1 }));
            // Optionally handle the fetched data
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };



    useEffect(() => {
        dispatch(getNotification({ page: page, limit: limit }));
        if (page === 1) {
            setNotificationData([]);
        }
    }, [page]);

    const fetchMoreData = () => {
        if (hasMore) {
            setPage(prevPage => prevPage + 1);
        }
    };

    const { notifications, loading, error } = useSelector(state => ({
        notifications: state.Notification.notificationData,
        loading: state.Notification.loading,
        error: state.Notification.error
    }));

    useEffect(() => {
        // Set document title only on mount
        document.title = "Notification";
        changeNotificationStatus()
    }, []);

    useEffect(() => {
        if (error) {
            // Handle error
            console.error("Error fetching notifications:", error);
        }
    }, [error]);

    useEffect(() => {
        if (notifications) {
            setNotificationData(prevItems => {
                if (page === 1) {
                    return notifications;
                } else {
                    return [...prevItems, ...notifications];
                }
            });
            setHasMore(notifications.length >= limit);
            // if (notifications.length < limit || notifications.length === 0) {
            //     setHasMore(false);
            // }
        }
    }, [notifications]);


    if (loading && page === 1) {
        return (
            <div className="spinner center">
                <Spin />
            </div>
        );
    }

    return (
        <div className='notification_wrap'>
            {notificationData.length > 0 ? (
                <InfiniteScroll
                    dataLength={notificationData.length}
                    next={fetchMoreData}
                    hasMore={hasMore}
                    loader={
                        <div className="spinner center" key={0}>
                            <Spin />
                        </div>
                    }
                // endMessage={<p className='no_more_text'>No more items to load</p>}

                >
                    {notificationData.map((notification, index) => (
                        <NotificationCard
                            isRead={notification?.is_read}
                            adId={notification.ad_id}
                            key={index}
                            title={notification.title}
                            description={notification.message}
                            date={notification?.created_at}
                            imageUrl={notification?.image_url}
                            catalogTitle={notification?.catalog_title}
                            catalogDescription={notification?.catalog_description}
                            type={notification?.type}
                            index={index}
                        />
                    ))}
                </InfiniteScroll>
            ) : (
                <NoResults
                    type={'notification'}
                    title={'You have no notifications.'}
                />
            )}
        </div>
    );
};

export default Notification;
